<template>
  <v-container
    class="pa-0"
    :style="{ maxWidth: maxWidth + 'px'}"
  >
    <v-layout
      v-if="removeSpace && title && caption"
      row
      wrap
      justify-center
    >
      <v-flex xs12>
        <v-layout
          column
          justify-center
        >
          <div
            class="iconColor--text font-weight-bold subheading"
          >
            {{ title }}
          </div>
          <div class="iconColor--text body-1">
            {{ caption }}
          </div>
        </v-layout>
        <v-switch
          v-model="dupChecked"
          :disabled="disabled"
          :label="label"
          class="toggle"
          color="primary"
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-else-if="title || caption"
      row
      wrap
      align-center
      justify-space-between
    >
      <div class="toggle-content">
        <div
          class="iconColor--text font-weight-bold subheading"
        >
          {{ title }}
        </div>
        <div class="iconColor--text body-1">
          {{ caption }}
        </div>
      </div>
      <v-switch
        v-model="dupChecked"
        :disabled="disabled"
        class="toggle"
        :label="label"
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
    >
      <v-switch
        v-model="dupChecked"
        :disabled="disabled"
        :label="label"
        class="toggle"
        color="primary" 
      />
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'Toggle',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    removeSpace: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dupChecked: false
    };
  },
  computed: {
    maxWidth() {
      if (this.title || this.caption) {
        return 750;
      } else {
        return this.label ? 128 : 40;
      }
    }
  },
  watch: {
    checked: {
      handler(val) {
        this.dupChecked = val;
      },
      immediate: true
    },
    dupChecked: {
      handler(val) {
        this.$emit('change', val);
      },
      deep: true
    }
  }
};
</script>
<style>
.toggle {
  max-width: 40px;
}
.max-toggle {
  max-width: 750px;
}
</style>

